define(function (require) {
  var _ = require("underscore");
  var Backbone = require("backbone");
  var AccountDiscountModel = require("common/model/account-discount");
  var xhrUris = require("common/xhr-uris");

  return Backbone.Collection.extend({
    url: xhrUris.accountDiscountCodes,
    model: AccountDiscountModel,

    parse (data) {
      var list = data;
      return list;
    },

    getDiscounts () {
      return this.filter(function () {
        return true;
      });
    },

    getDiscountsIndexedByCode () {
      var discounts = this.getDiscounts();
      var codes = this.map(function (discount) {
        return discount.get("code");
      });

      return _.object(codes, discounts);
    },

    inUseDiscounts () {
      return this.filter(function (accountDiscount) {
        return accountDiscount.inUse;
      });
    },

    notInUseDiscounts () {
      return this.filter(function (accountDiscount) {
        return !accountDiscount.inUse;
      });
    },

    setDiscountUseState (code, inUse) {
      var discount = this.find(function (testDiscount) {
        return testDiscount.get("code") === code;
      });

      if (discount) {
        discount.inUse = inUse;
      }
    },

    inUseTotal () {
      return _.reduce(this.inUseDiscounts(), function (total, discount) {
        // Round to the nearest penny/cent (to account for the impression
        // of the Number type).
        var unroundedTotal = total + discount.getInUseValue();
        var roundedTotal = Math.round(unroundedTotal * 100) / 100;

        return roundedTotal;
      }, 0);
    }
  });
});
